module.exports = __webpack_public_path__ + "images/sprites/ui/circle_arrow_bk_691410e658584898d17c8e5e977c7af1.png";